// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1LW02","title":"Images45_title__kP2H8","images":"Images45_images__3XpcB"};